import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ClaimsTableDataType } from "types/DataTypes";

type InitialState = {
  claim: ClaimsTableDataType | null;
  showArchiveModal: boolean;
  showResolveCMSErrorModal: boolean;
};

const claimSlice = createSlice({
  name: "claim",
  initialState: {
    claim: null,
    // show archive claim confirmation modal
    showArchiveModal: false,
    // show resolve CMS error confirmation modal
    showResolveCMSErrorModal: false,
  } as InitialState,
  reducers: {
    setClaim(state, action: PayloadAction<ClaimsTableDataType>) {
      state.claim = action.payload;
    },
    setShowArchiveModal: (state, action: PayloadAction<boolean>) => {
      state.showArchiveModal = action.payload;
    },
    setShowResolveCMSErrorModal: (state, action: PayloadAction<boolean>) => {
      state.showResolveCMSErrorModal = action.payload;
    },
  },
});

const { reducer } = claimSlice;

export const { setClaim, setShowArchiveModal, setShowResolveCMSErrorModal } =
  claimSlice.actions;

export default reducer;
